const ChatbotTypingIndicator = () => {
  return (
    <div className='chatbot-typing-indicator'>
      <div className='chatbot-typing-indicator__dot-wrapper'>
        <div className='chatbot-typing-indicator__dot'></div>
        <div className='chatbot-typing-indicator__dot'></div>
        <div className='chatbot-typing-indicator__dot'></div>
      </div>
    </div>
  )
}
export default ChatbotTypingIndicator